module.exports = __webpack_public_path__ + "img/integrations-klaviyo.3192c60f.png";